import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { BooleanInput, NumberInput } from 'react-admin'
import { drinkVS } from 'services/validations/catalog/drink'
import MainProductForm, {
  MainProductFormProps,
} from 'ui-shared/Forms/MainProductForm'
import KToolTip from 'ui-shared/KTooltip'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import VariantsFormPartial from './VariantsFormPartial'

type DrinkFormProps = MainProductFormProps

const DrinkForm: React.FC<DrinkFormProps> = (props) => (
  <MainProductForm {...props} resolver={yupResolver(drinkVS)}>
    <NumberInput source="minQuantity" />
    <KToolTip title="form.fields.drinkPerUnitTooltip">
      <KNumberInput
        label="form.fields.drinksPerUnit"
        source="drinksPerUnit"
        defaultValue={1}
      />
    </KToolTip>
    <BooleanInput
      source="hasMultipleVariants"
      label="form.fields.hasMultipleVariants"
    />
    <VariantsFormPartial />
  </MainProductForm>
)

export default DrinkForm
